import React from 'react';

import {
  BaseWidget,
  LabelledText
} from 'modules';
import {
  Grid,
  Skeleton
} from '@mui/material';

import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <BaseWidget.FC title="Device Information">
      <Grid container>
        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Model"
            text={queryTuple.loading ? <Skeleton /> : queryTuple.data.device?.model} />

          <LabelledText.FC
            title="SKU"
            text={queryTuple.loading ? <Skeleton /> : queryTuple.data.device?.sku} />

          <LabelledText.FC
            title="IMEI/ICCID"
            text={queryTuple.loading ? <Skeleton /> : queryTuple.data.device?.serialNumber} />
        </Grid>

        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Software Version"
            text={queryTuple.loading ? <Skeleton /> : queryTuple.data.device?.softwareVersion} />
        </Grid>
      </Grid>
    </BaseWidget.FC>
  );
};
